/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePlanBaselineRequest
 */
export interface CreatePlanBaselineRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePlanBaselineRequest
     */
    label?: string;
}

/**
 * Check if a given object implements the CreatePlanBaselineRequest interface.
 */
export function instanceOfCreatePlanBaselineRequest(value: object): value is CreatePlanBaselineRequest {
    return true;
}

export function CreatePlanBaselineRequestFromJSON(json: any): CreatePlanBaselineRequest {
    return CreatePlanBaselineRequestFromJSONTyped(json, false);
}

export function CreatePlanBaselineRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePlanBaselineRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'] == null ? undefined : json['label'],
    };
}

export function CreatePlanBaselineRequestToJSON(json: any): CreatePlanBaselineRequest {
    return CreatePlanBaselineRequestToJSONTyped(json, false);
}

export function CreatePlanBaselineRequestToJSONTyped(value?: CreatePlanBaselineRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
    };
}

